import React, { useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import './QRExamples.css';

const QR_EXAMPLES = [
  {
    route: 'oplata-yur',
    icon: '₽₽',
    title: 'Оплата юрлицу или ИП',
    description: 'Кодирует реквизиты компании, назначение и сумму платежа.',
    example: 'Оплата услуг СНТ.',
    scanHint: 'Отсканируй приложением банка (Сбербанк-Онлайн, Тинькофф и т. п.)',
    href: '/page/QRcode_dlya_oplaty.html',
    payload: 'ST00012|Name=СНТ "Ворсинка"|PersonalAcc=40703810138000015316|BankName=ПАО СБЕРБАНК|BIC=044525225|CorrespAcc=30101810400000000225|KPP=500401001|PayeeINN=5004010697|lastName=Петров А.И.|Purpose=за услуги|Sum=15000'
  },
  {
    route: 'perevod',
    icon: '→₽',
    title: 'Перевод физлицу',
    description: 'Передаёт банковские реквизиты получателя для перевода по номеру.',
    example: 'Перевод по реквизитам',
    payload: 'https://www.sberbank.com/sms/pbpn?requisiteNumber=79003213210'
  },
  {
    route: 'yamoney',
    icon: 'Ю',
    title: 'Кошелёк ЮMoney',
    description: 'Открывает страницу перевода на указанный электронный кошелёк.',
    example: 'Перевод на кошелёк ЮMoney',
    payload: 'https://yoomoney.ru/to/4100115861099027'
  },
  {
    route: 'url',
    icon: '↗',
    title: 'Ссылка на сайт',
    description: 'Открывает сайт, каталог, страницу товара или любой интернет-адрес.',
    example: 'https://sbqr.ru',
    payload: 'https://sbqr.ru'
  },
  {
    route: 'text',
    icon: 'Aa',
    title: 'Произвольный текст',
    description: 'Показывает заметку, инструкцию, промокод или другую текстовую информацию.',
    example: 'Спасибо, что выбрали SBQR!',
    payload: 'Спасибо, что выбрали SBQR!'
  },
  {
    route: 'phone',
    icon: '☎',
    title: 'Номер телефона',
    description: 'Предлагает сразу позвонить по указанному номеру без ручного набора.',
    example: '+7 999 123-45-67',
    payload: 'tel:+79991234567'
  },
  {
    route: 'telegram',
    icon: '✈',
    title: 'Telegram',
    description: 'Ведёт в профиль, канал или чат Telegram.',
    example: 't.me/sbqr_online',
    payload: 'https://t.me/sbqr_online'
  },
  {
    route: 'wifi',
    icon: '⌁',
    title: 'Wi-Fi сеть',
    description: 'Подключает смартфон к сети без ввода имени и пароля вручную.',
    example: 'Сеть: SBQR Guest',
    payload: 'WIFI:T:WPA;S:SBQR Guest;P:sbqr-demo-2026;;'
  },
  {
    route: 'vcard',
    icon: 'ID',
    title: 'Визитка vCard',
    description: 'Сохраняет имя, телефон, почту, компанию и должность в контакты.',
    example: 'Анна Смирнова · SBQR',
    payload: 'BEGIN:VCARD\nVERSION:3.0\nFN:Анна Смирнова\nORG:SBQR\nTEL:+79991234567\nEMAIL:hello@sbqr.ru\nEND:VCARD'
  },
  {
    route: 'geo',
    icon: '⌖',
    title: 'Геопозиция',
    description: 'Открывает точку по координатам в удобном картографическом сервисе.',
    example: 'Москва, Красная площадь',
    payload: 'geo:55.753930,37.620795?q=55.753930,37.620795(Красная площадь)'
  },
  {
    route: 'calendar-event',
    icon: '31',
    title: 'Событие в календаре',
    description: 'Добавляет встречу или мероприятие с датой, временем и описанием.',
    example: 'Презентация · 18 сентября, 12:00',
    payload: 'BEGIN:VEVENT\nSUMMARY:Презентация SBQR\nDTSTART:20260918T090000Z\nDTEND:20260918T100000Z\nLOCATION:Москва\nEND:VEVENT'
  },
  {
    route: 'sbp',
    icon: '₽',
    title: 'Оплата через СБП',
    description: 'Формирует код для быстрой оплаты через приложение банка.',
    example: 'Оплата заказа через СБП',
    payload: 'https://sbqr.ru/qr/create/sbp/'
  }
];

function QRExamples() {
  useEffect(() => {
    const previousTitle = document.title;
    const description = document.querySelector('meta[name="description"]');
    const previousDescription = description ? description.content : '';

    document.body.classList.add('examples-page-active');
    document.title = 'Примеры QR-кодов для разных задач — SBQR';
    if (description) {
      description.content = 'Примеры QR-кодов для ссылок, текста, Wi-Fi, визиток, геопозиции, платежей и других задач.';
    }

    return () => {
      document.body.classList.remove('examples-page-active');
      document.title = previousTitle;
      if (description) {
        description.content = previousDescription;
      }
    };
  }, []);

  return (
    <div className="examples-page">
      <header className="examples-header">
        <a className="examples-header__brand" href="/" aria-label="SBQR — на главную">
          <span className="examples-header__mark" aria-hidden="true">S</span>
          <span>SBQR</span>
        </a>
        <nav className="examples-header__nav" aria-label="Основная навигация">
          <a href="/qr/create/url/">Создать QR-код с дизайном</a>
          <a href="/page/QRcode_dlya_oplaty.html">Создать QR-код для оплаты</a>
          <a href="/wp/">Инструкции</a>
          <a className="examples-header__button" href="/#choice">Связаться</a>
        </nav>
      </header>

      <main>
        <section className="examples-hero">
          <div className="examples-hero__eyebrow"><span /> 12 готовых сценариев</div>
          <h1>Примеры QR-кодов<br /><em>для любых задач</em></h1>
          <p>
            Посмотрите, как работают разные типы QR-кодов. Наведите камеру смартфона
            на любой пример или сразу создайте свой — бесплатно и без регистрации.
          </p>
          <a className="examples-hero__cta" href="#examples">Смотреть примеры <span aria-hidden="true">↓</span></a>
        </section>

        <section className="examples-catalog" id="examples" aria-labelledby="examples-title">
          <div className="examples-catalog__heading">
            <div>
              <span className="examples-catalog__number">01</span>
              <h2 id="examples-title">Выберите тип QR-кода</h2>
            </div>
            <p>Каждый код можно настроить: изменить цвет и форму, добавить логотип и скачать в нужном формате.</p>
          </div>

          <div className="examples-grid">
            {QR_EXAMPLES.map((item, index) => (
              <article className="qr-example" key={item.route}>
                <div className="qr-example__topline">
                  <span className="qr-example__index">{String(index + 1).padStart(2, '0')}</span>
                  <span className="qr-example__icon" aria-hidden="true">{item.icon}</span>
                </div>
                <div className="qr-example__content">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
                <div className="qr-example__preview">
                  <div className="qr-example__code">
                    <QRCodeSVG value={item.payload} size={148} level="M" marginSize={1} />
                  </div>
                  <div className="qr-example__scan">
                    <span>Пример</span>
                    <strong>{item.example}</strong>
                    <small>{item.scanHint || 'Отсканируйте камерой'}</small>
                  </div>
                </div>
                <a className="qr-example__link" href={item.href || `/qr/create/${item.route}/`}>
                  Создать такой QR-код <span aria-hidden="true">↗</span>
                </a>
              </article>
            ))}
          </div>
        </section>

        <section className="examples-banner">
          <div>
            <span className="examples-banner__label">Просто и бесплатно</span>
            <h2>Не нашли подходящий пример?</h2>
            <p>Начните со ссылки или текста — дизайн QR-кода можно изменить на следующем шаге.</p>
          </div>
          <a href="/qr/create/url/">Создать QR-код <span aria-hidden="true">↗</span></a>
        </section>
      </main>

      <footer className="examples-footer">
        <a className="examples-footer__brand" href="/">SBQR</a>
        <p>Бесплатный генератор QR-кодов с дизайном</p>
        <a href="mailto:analiticexpertpay@gmail.com">analiticexpertpay@gmail.com</a>
      </footer>
    </div>
  );
}

export default QRExamples;
